export default ({ next, store }) => {
  if (!store.getters.me) {
    return next({ name: 'login' })
  }

  return next()
}
